var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopyIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.91192 6.45801V5.41401C5.91192 4.56276 6.5174 3.84051 7.3278 3.77001C7.59507 3.74751 7.86377 3.72726 8.13248 3.71001M11.286 14.333H12.8982C13.3258 14.333 13.7358 14.1552 14.0382 13.8388C14.3405 13.5223 14.5104 13.0931 14.5104 12.6455V5.41401C14.5104 4.56276 13.9049 3.84051 13.0945 3.77001C12.8265 3.74674 12.5583 3.72674 12.2898 3.71001M12.2898 3.71001C12.1881 3.36553 11.9829 3.06421 11.7057 2.85016C11.4284 2.63612 11.093 2.52059 10.7486 2.52051H9.67375C9.32927 2.52059 8.99386 2.63612 8.71664 2.85016C8.43942 3.06421 8.23496 3.36553 8.13319 3.71001C8.08662 3.86751 8.06154 4.03476 8.06154 4.20801V4.77051H12.3608V4.20801C12.3608 4.03476 12.3364 3.86751 12.2898 3.71001ZM11.286 14.8955V13.4893C11.286 12.8179 11.0312 12.1741 10.5777 11.6994C10.1241 11.2247 9.50902 10.958 8.86764 10.958H7.79284C7.57904 10.958 7.37401 10.8691 7.22283 10.7109C7.07166 10.5526 6.98673 10.338 6.98673 10.1143V8.98926C6.98673 8.31793 6.73194 7.6741 6.27842 7.19939C5.8249 6.72469 5.20979 6.45801 4.56841 6.45801H3.76231M4.83712 6.45801H3.49361C3.04864 6.45801 2.6875 6.83601 2.6875 7.30176V16.3018C2.6875 16.7675 3.04864 17.1455 3.49361 17.1455H10.4799C10.9248 17.1455 11.286 16.7675 11.286 16.3018V13.208C11.286 11.4178 10.6065 9.70091 9.39714 8.43504C8.18774 7.16917 6.54746 6.45801 4.83712 6.45801Z",
    stroke: "#4B5563",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopyIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copy-icon.ce7d5f9b0a4d29d7263a04a9361466b7.svg";